import HeaderBanner from './HeaderBanner';
const OctopussRetails = () => {

    return (
        <>
            <HeaderBanner heading={'Octopuss Retails'} imagePath="assets/images/banners/retails.avif" />
            <section className="about about-1" id="about-1" style={{ background: 'rgb(235, 230, 230)', marginTop: '30px' }}>
                <div className="container">
                    <div className="row" >
                        <div className='center-heading'>
                            <h2 className="heading-with-border center-heading">Octopuss Retails</h2>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default OctopussRetails;